import axios from 'axios'
import router from '../router/index'
import store from '../store'
import Vue from 'vue'

import applicationUserManager from '../Auth/applicationusermanager'

let base = process.env.VUE_APP_BASE_API
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base =
//   process.env.NODE_ENV == 'production' ? 'http://hradminapi.hroot.com' : ''

// 请求延时
axios.defaults.timeout = 120000

var storeTemp = store
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date()
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

    if (
      storeTemp.state.token &&
      curTime < expiretime &&
      storeTemp.state.tokenExpire
    ) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = 'Bearer ' + storeTemp.state.token
    }

    saveRefreshtime()

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    let errInfo = { success: false, message: '错误' }
    // 超时请求处理
    var originalRequest = error.config
    if (
      error.code == 'ECONNABORTED' &&
      error.message.indexOf('timeout') != -1 &&
      !originalRequest._retry
    ) {
      errInfo.message = '请求超时！'
      originalRequest._retry = true
    } else if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date()
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({ token: window.localStorage.Token }).then(
            (res) => {
              if (res.success) {
                Vue.prototype.$message({
                  message: 'refreshToken success! loading data...',
                  type: 'success',
                })

                store.commit('saveToken', res.response.token)

                var curTime = new Date()
                var expiredate = new Date(
                  curTime.setSeconds(
                    curTime.getSeconds() + res.response.expires_in
                  )
                )
                store.commit('saveTokenExpire', expiredate)

                error.config.__isRetryRequest = true
                error.config.headers.Authorization =
                  'Bearer ' + res.response.token
                return axios(error.config)
              } else {
                // 刷新token失败 清除token信息并跳转到登录页面
                ToLogin()
              }
            }
          )
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin()
        }
        errInfo.message = '失败！验证失效，请重新登录'
      }
      // 403 无权限
      else if (error.response.status == 403) {
        errInfo.message = '失败！该操作无权限'
      }
      // 429 ip限流
      else if (error.response.status == 429) {
        errInfo.message = '刷新次数过多，请稍事休息重试！'
      } else if (error.response.status == 404) {
        // 404 不存在
        errInfo.message = '失败！访问接口不存在'
      } else if (error.response.status == 500) {
        // 500 服务器异常
        errInfo.message = '失败！服务器异常'
      } else if (error.response.status == 405) {
        // 405 请求http方法错误
        errInfo.message = '失败！请求http方法错误'
      } else if (error.response.status == 415) {
        // 415 参数没有指定Body还是Query
        errInfo.message = '失败！参数没有指定Body还是Query'
      } else {
        //其他错误参数
        errInfo.message = '失败！请求错误' + error.response.status
      }
    } else {
      errInfo.message = '失败！服务器断开'
    }
    Vue.prototype.$message({
      message: errInfo.message,
      type: 'error',
    })
    return errInfo // 返回接口返回的错误信息
  }
)

export const BaseApiUrl = base

// 登录
export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/login/jwttoken3.0`, { params: params })
    .then((res) => res.data)
}
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data)
}

export const refreshToken = (params) => {
  return axios
    .get(`${base}/api/login/RefreshToken`, { params: params })
    .then((res) => res.data)
}

export const saveRefreshtime = (params) => {
  let nowtime = new Date()
  let lastRefreshtime = window.localStorage.refreshtime
    ? new Date(window.localStorage.refreshtime)
    : new Date(-1)
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

  let refreshCount = 1 //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount)
    window.localStorage.refreshtime = lastRefreshtime
  } else {
    window.localStorage.refreshtime = new Date(-1)
  }
}
const ToLogin = (params) => {
  store.commit('saveToken', '')
  store.commit('saveTokenExpire', '')
  store.commit('saveTagsData', '')
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('NavigationBar')

  if (global.IS_IDS4) {
    applicationUserManager.login()
  } else {
    router.replace({
      path: '/login',
      query: { redirect: router.currentRoute.fullPath },
    })
    //window.location.reload()
  }
}

export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, { params: params })
    .then((res) => res.data)
}

export function testapi2() {
  console.log('api is ok.')
}

export const testapi = (pa) => {
  console.log('api is ok.')
}

// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, { params: params })
}
export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, { params: params })
}
export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params)
}
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params)
}
export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params }) //没做
}
export const updPwd = (params) => {
  return axios.post(`${base}/api/user/UpdPwd`, params)
}

// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, { params: params })
}
export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, { params: params })
}
export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params)
}
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params)
}

// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, { params: params })
}
export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, { params: params })
}
export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params)
}
export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params)
}

// 菜单模块管理
export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, { params: params })
}
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, { params: params })
}
export const migratePermissionTable = (params) => {
  return axios.get(`${base}/api/permission/MigratePermission`, {
    params: params,
  })
}
export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, { params: params })
}
export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params)
}
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params)
}
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  })
}
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  })
}

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params)
}
export const getNavigationBar = (params) => {
  return axios
    .get(`${base}/api/permission/GetNavigationBar`, { params: params })
    .then((res) => res.data)
}

// Bug模块管理
export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, { params: params })
}
export const removeBug = (params) => {
  return axios.delete(`${base}/api/TopicDetail/delete`, { params: params })
}
export const editBug = (params) => {
  return axios.put(`${base}/api/TopicDetail/update`, params)
}
export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params)
}

// 博客模块管理
export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, { params: params })
}
export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params })
}
export const editBlog = (params) => {
  return axios.put(`${base}/api/Blog/update`, params)
}
export const removeBlog = (params) => {
  return axios.delete(`${base}/api/Blog/delete`, { params: params })
}

// 日志
export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, { params: params })
}
export const getRequestApiinfoByWeek = (params) => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, {
    params: params,
  })
}
export const getAccessApiByDate = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, { params: params })
}
export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, { params: params })
}
export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, { params: params })
}
export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params })
}
export const getIds4UsersGrow = (params) => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params })
}
export const getActiveUsers = (params) => {
  return axios.get(`${base}/api/Monitor/GetActiveUsers`, { params: params })
}

// Task管理
export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, { params: params })
}
export const removeTask = (params) => {
  return axios.delete(`${base}/api/TasksQz/delete`, { params: params })
}
export const editTask = (params) => {
  return axios.put(`${base}/api/TasksQz/put`, params)
}
export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params)
}

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, { params: params })
}
export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, { params: params })
}
export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params })
}
export const pauseJob = (params) => {
  return axios.get(`${base}/api/TasksQz/PauseJob`, { params: params })
}
export const resumeJob = (params) => {
  return axios.get(`${base}/api/TasksQz/ResumeJob`, { params: params })
}
export const getTaskNameSpace = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskNameSpace`, { params: params })
}
export const GetTaskLogs = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskLogs`, { params: params })
}
export const GetTaskOverview = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskOverview`, { params: params })
}
// ids4
export const getAchieveUsers_IS4 = (params) => {
  return axios.get(`${base}/is4api/GetAchieveUsers`, { params: params })
}

//微信公众号
export const getWeChatAccount = (params) => {
  return axios.get(`${base}/api/WeChatConfig/get`, { params: params })
}
export const removeWeChatAccount = (params) => {
  return axios.delete(`${base}/api/WeChatConfig/delete`, { params: params })
}
export const batchDeleteChatAccount = (params) => {
  return axios.delete(`${base}/api/WeChatConfig/BatchDelete`, {
    params: params,
  })
}
export const addWeChatAccount = (params) => {
  return axios.post(`${base}/api/WeChatConfig/post`, params)
}
export const updateWeChatAccount = (params) => {
  return axios.put(`${base}/api/WeChatConfig/put`, params)
}
export const getWeChatTemplate = (params) => {
  return axios.get(`${base}/api/WeChat/GetTemplate`, { params: params }) //获取模板
}
export const refreshWeChatToken = (params) => {
  return axios.get(`${base}/api/WeChat/RefreshToken`, { params: params }) //更新Token
}
export const getWeChatMenu = (params) => {
  return axios.get(`${base}/api/WeChat/GetMenu`, { params: params }) //获取微信菜单
}
export const updateWeChatMenu = (params) => {
  return axios.put(`${base}/api/WeChat/updateMenu`, params) //更新微信菜单
}
export const getWeChatCompany = (params) => {
  return axios.get(`${base}/api/WeChatCompany/get`, { params: params })
}
export const removeWeChatCompany = (params) => {
  return axios.delete(`${base}/api/WeChatCompany/delete`, { params: params })
}
export const batchDeleteWeChatCompany = (params) => {
  return axios.delete(`${base}/api/WeChatCompany/BatchDelete`, {
    params: params,
  })
}
export const addWeWeChatCompany = (params) => {
  return axios.post(`${base}/api/WeChatCompany/post`, params)
}
export const updateWeChatCompany = (params) => {
  return axios.put(`${base}/api/WeChatCompany/put`, params)
}
export const getWeChatPushLog = (params) => {
  return axios.get(`${base}/api/WeChatPushLog/get`, { params: params })
}
export const getWeChatSubUser = (params) => {
  return axios.get(`${base}/api/WeChat/GetSubUsers`, { params: params })
}
export const getWeChatBindUser = (params) => {
  return axios.get(`${base}/api/WeChatSub/get`, { params: params })
}
export const pushTestMsg = (params) => {
  return axios.post(`${base}/api/WeChat/PushTxtMsg`, params)
}
export const pushCardMsg = (params) => {
  return axios.post(`${base}/api/WeChat/PushCardMsg`, params)
}

// 部门模块管理
export const getDepartmentListPage = (params) => {
  return axios.get(`${base}/api/department/get`, { params: params })
}
export const getDepartmentTreeTable = (params) => {
  return axios.get(`${base}/api/department/getTreeTable`, { params: params })
}

export const removeDepartment = (params) => {
  return axios.delete(`${base}/api/department/delete`, { params: params })
}
export const editDepartment = (params) => {
  return axios.put(`${base}/api/department/put`, params)
}
export const addDepartment = (params) => {
  return axios.post(`${base}/api/department/post`, params)
}
export const getDepartmentTree = (params) => {
  return axios.get(`${base}/api/department/getDepartmentTree`, {
    params: params,
  })
}

// 显示客户账号
export const getDeptActivityList = (params) => {
  console.log(params)
  return axios.post(`${base}/api/DeptActivity/list`, params)
}
// 根据选中的部门显示当前部门的用户
export const getUserListByDepId = (params) => {
  return axios.get(
    `${base}/api/User/GetUserNameList/list/${params.departmentId}`
  )
}
// 可录入参会类别
export const getParticipantTypeList = () => {
  return axios.get(`${base}/api/ParticipantType/list`, {})
}
// 适用活动
export const getActivityList = (params) => {
  return axios.get(`${base}/api/Activity/list/${params}`)
}
export const getActivityPageList = (params) => {
  return axios.post(`${base}/api/Activity/list`, params)
}
export const getActivityRecords = (params) => {
  return axios.post(`${base}/api/Activity/records`, params)
}
export const addOrUpdctivity = (params) => {
  return axios.post(`${base}/api/Activity/AddOrUpd`, params)
}
export const getActivityInfo = (params) => {
  return axios.get(`${base}/api/Activity/info/${params}`, {})
}
export const getDefaultActivityInfo = () => {
  return axios.get(`${base}/api/Activity/defaultInfoForRegister`, {})
}
export const addOrUpdDeptActivity = (params) => {
  return axios.post(`${base}/api/DeptActivity/Add`, params)
}

export const getAttendeeList = (params) => {
  return axios.post(`${base}/api/Attendee/list`, params)
}
export const addOrUpdAttendee = (params) => {
  return axios.post(`${base}/api/Attendee/addOrUpd`, params)
}
export const getAttendeeById = (params) => {
  return axios.get(`${base}/api/Attendee/${params}`, {})
}

export const importAttendeeFile = (params) => {
  return axios.post(
    `${base}/api/Attendee/import/${params.activityId}`,
    params.form,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    }
  )
}
export const syncAttendee = (params) => {
  return axios.get(`${base}/api/Attendee/sync/${params}`)
}
export const enabledAttendee = (params) => {
  return axios.post(`${base}/api/Attendee/enable`, params)
}

export const getApplyAwardList = (params) => {
  return axios.post(`${base}/api/ApplyAward/list`, params)
}
export const addOrUpdApplyAward = (params) => {
  return axios.post(`${base}/api/ApplyAward/addOrUpd`, params)
}
export const getApplyAwardById = (params) => {
  return axios.get(`${base}/api/ApplyAward/${params}`, {})
}
export const registerApplyAward = (params) => {
  return axios.post(`${base}/api/ApplyAward/Register`, params)
}
export const enabledApplyAward = (params) => {
  return axios.post(`${base}/api/ApplyAward/enable`, params)
}
export const syncApplyAward = (params) => {
  return axios.get(`${base}/api/ApplyAward/sync/${params}`)
}

export const getApplyAwardTypeList = (params) => {
  return axios.get(`${base}/api/ApplyAwardType/list`, {})
}

export const getApplyAwardTypeListByAwardId = (params) => {
  return axios.post(`${base}/api/ApplyAwardType/list`, params)
}

export const getOSSSts = (params) => {
  console.log('----------------------')
  return axios.get(`${base}/api/aliyun/oss/sts`, {})
}
export const getTopicCollectionPageList = (params) => {
  return axios.post(`${base}/api/DataCollection/topic/list`, params)
}
// 获取投票名称列表
export const getTopicNameList = (params) => {
  return axios.get(`${base}/api/DataCollection/topic/name/list`, {})
}
// 投票列表
export const getTopicVoteList = (params) => {
  return axios.post(`${base}/api/DataCollection/topic/vote/list`, params)
}

export const AddOrUpdTopic = (params) => {
  return axios.post(`${base}/api/DataCollection/topic/AddOrUpd`, params)
}

export const getResearchReportDownList = (params) => {
  return axios.post(`${base}/api/ResearchReport/download/history`, params)
}
export const getResearchReportPageList = (params) => {
  return axios.post(`${base}/api/ResearchReport/list`, params)
}
export const getResearchReportInfo = (params) => {
  return axios.get(`${base}/api/ResearchReport/info/${params}`, {})
}
export const addOrUpdResearchReport = (params) => {
  return axios.post(`${base}/api/ResearchReport/addOrUpd`, params)
}
export const delResearchReport = (params) => {
  return axios.delete(`${base}/api/ResearchReport/delete/${params}`, {})
}
export const offlineResearchReport = (params) => {
  return axios.get(`${base}/api/ResearchReport/offline/${params}`, {})
}
export const getSolutionGenreList = (params) => {
  return axios.get(`${base}/api/SolutionGenre/list`, {})
}
export const getBaseTagList = (params) => {
  return axios.get(`${base}/api/BaseTag/list`, {})
}

export const getVideoPageList = (params) => {
  return axios.post(`${base}/api/Video/list`, params)
}
export const getVideoInfo = (params) => {
  return axios.get(`${base}/api/Video/info/${params}`, {})
}
export const getVideoListByTopic = (params) => {
  return axios.get(`${base}/api/Video/list/topic?topic=${params}`, {})
}
export const addOrUpdVideo = (params) => {
  return axios.post(`${base}/api/Video/addOrUpd`, params)
}

export const getVideoCoursePageList = (params) => {
  return axios.post(`${base}/api/VideoCourse/list`, params)
}
export const getVideoCourseInfo = (params) => {
  return axios.get(`${base}/api/VideoCourse/info/${params}`, {})
}
export const addOrUpdVideoCourse = (params) => {
  return axios.post(`${base}/api/VideoCourse/addOrUpd`, params)
}

export const getSlyFuzzySearchList = (params) => {
  return axios.get(`${base}/api/Sly/FuzzySearch/${params}/list`, {})
}

// 活动报名信息列表
export const getActivityRegList = (params) => {
  return axios.post(`${base}/api/ActivityRegistration/list`, params)
}
// 活动报名信息列表——报名来源
export const getActivityRegistrationSourceList = (params) => {
  return axios.get(`${base}/api/ActivityRegistration/source/list/${params}`, {})
}
// 活动报名信息列表——报名方式
export const getActivityRegistrationFromList = (params) => {
  return axios.get(`${base}/api/ActivityRegistration/from/list`, {})
}
// 活动报名信息列表——签到
export const getActivityRegistrationSign = (params) => {
  return axios.post(`${base}/api/ActivityRegistration/sign`, params)
}
// 活动报名信息列表——同意报名
export const enabledActivityRegistrationAgreeReg = (params) => {
  return axios.get(
    `${base}/api/ActivityRegistration/agreeReg/${params.regId}/${params.agree}`,
    {}
  )
}
// 活动报名信息信息统计（报名人数、有效报名、签到数据、签到率）
export const ActivityRegistrationStatistic = (params) => {
  return axios.get(`${base}/api/ActivityRegistration/statistic/${params}`, {})
}

export const importActivityRegistrationFile = (params) => {
  return axios.post(
    `${base}/api/ActivityRegistration/import/${params.activityId}`,
    params.form,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    }
  )
}

// 发送通知任务
export const SendActivityRegistrationNotice = (params) => {
  return axios.post(`${base}/api/ActivityRegistration/SendNotice`, params)
}
export const GetSendActivityRegistrationNoticeCount = (params) => {
  return axios.post(`${base}/api/ActivityRegistration/SendNotice/count`, params)
}
// 活动报名信息列表——获取会员次数列表
export const getMemberTypeList = (params) => {
  return axios.get(
    `${base}/api/ActivityRegistration/memberTypeList/${params}`,
    {}
  )
}
// 活动报名信息列表——核销
export const updMemberAvailableTimes = (params) => {
  return axios.post(
    `${base}/api/ActivityRegistration/updMemberAvailableTimes`,
    params
  )
}
// 活动详情页——活动类型
export const getActivityTypes = (params) => {
  return axios.get(`${base}/api/Activity/types`, params)
}
// 活动详情页——活动分类
export const getActivityCategorList = (params) => {
  return axios.get(`${base}/api/Activity/list`, params)
}
// 活动——报名信息——新增、编辑报名
export const ActivityRegisterAddOrUpd = (params) => {
  return axios.post(`${base}/api/ActivityRegistration/AddOrUpd`, params)
}
//  活动——报名信息——新增和编辑时 根据输入的内容查询公司名称
export const getCustomerCompanyList = (params) => {
  return axios.get(`${base}/api/Customer/${params}/list`, {})
}
//  活动——报名信息——根据 报名ID 活动报名者信息
export const getActivityRegInfoList = (params) => {
  return axios.get(`${base}/api/ActivityRegistration/${params}`, {})
}
//  活动——结束报名
export const ActivityEndReg = (params) => {
  return axios.get(`${base}/api/Activity/endReg/${params}`, {})
}

// 活动配置——获取链接（表单链接、签到入口链接）
export const getActivityLinks = (params) => {
  return axios.get(`${base}/api/Activity/${params}/links`, {})
}
// 活动配置——修改活动推广链接
export const UpdPromotionalLink = (params) => {
  return axios.post(`${base}/api/Activity/UpdPromotionalLink`, params)
}
// 活动配置——默认表单配置
export const getfieldConfig = (params) => {
  return axios.get(`${base}/api/Activity/fieldConfig?activityId=${params}`, {})
}
// 活动配置——默认表单配置
export const UpdFieldConfig = (params) => {
  return axios.post(
    `${base}/api/Activity/${params.activityId}/UpdFieldConfig`,
    params.configs
  )
}
// 活动配置——获取默认活动信息
export const getActivityDefaultInfo = (params) => {
  return axios.get(`${base}/api/Activity/${params}/defaultInfo`, {})
}
// 活动配置——修改默认活动信息
export const ActivitySetDefault = (params) => {
  return axios.post(`${base}/api/Activity/setDefault`, params)
}

// 卓越获奖企业——查询
export const AwardCompanyList = (params) => {
  return axios.post(`${base}/api/AwardCompany/list`, params)
}
// 卓越获奖企业——新增
export const addOrUpdAwardCompany = (params) => {
  return axios.post(`${base}/api/AwardCompany/addOrUpd`, params)
}
// 卓越获奖企业——编辑
export const AwardCompanyById = (params) => {
  return axios.get(`${base}/api/AwardCompany/${params}`, {})
}
// 卓越获奖企业——有效、无效
export const AwardCompanyEnable = (params) => {
  return axios.post(`${base}/api/AwardCompany/enable`, params)
}
// 卓越获奖企业——导入
export const importAwardCompany = (params) => {
  return axios.post(
    `${base}/api/AwardCompany/import/${params.activityId}`,
    params.form,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    }
  )
}

export const activityRegistrationScanSign = (params) => {
  return axios.post(`${base}/api/ActivityRegistration/scanSign`, params)
}

// 讲师列表
export const getLecturerList = (params) => {
  return axios.post(`${base}/api/Lecturer/list`, params)
}
// 讲师 新增或编辑
export const AddOrUpdLecturer = (params) => {
  return axios.post(`${base}/api/Lecturer/AddOrUpd`, params)
}
// 讲师 根据 ID  获取讲师详情
export const getLecturerInfo = (params) => {
  return axios.get(`${base}/api/Lecturer/info/${params}`, {})
}
// 擅长领域
export const getGoodatList = (params) => {
  return axios.get(`${base}/api/Lecturer/goodat/list`, params)
}
// 对接人
export const getUserName = (params) => {
  return axios.get(`${base}/api/User/GetAllName`, params)
}
// 添加附件  附件类型(1:合同协议 2:相关文件留档)
export const AddLecturerAttachment = (params) => {
  return axios.post(`${base}/api/Lecturer/attachment/Add`, params)
}
// 根据讲师显示合同/协议、留档文件
export const LecturerAttachmentList = (params) => {
  return axios.get(`${base}/api/Lecturer/${params}/attachment/list`, {})
}
// 合同/协议 文件 失效
export const LecturerDisabled = (params) => {
  return axios.get(`${base}/api/Lecturer/disabled/${params}`, {})
}

// EDM 列表
export const ActivityEDMList = (params) => {
  return axios.get(`${base}/api/Activity/edm/list`, params)
}

export const getCompanyNames = (params) => {
  return axios.get(`${base}/api/awardcompany/companynames/${params}`, {})
}

// 通知列表
export const ActivityNoticeList = (params) => {
  return axios.post(`${base}/api/Notice/list`, params)
}
// 模板标签集合
export const getPlaceholderList = (params) => {
  return axios.get(`${base}/api/ActivityNoticeTemplate/placeholder`, params)
}
// 模板列表
export const getTemplateTypes = (params) => {
  return axios.get(`${base}/api/ActivityNoticeTemplate/types`, params)
}
// 模板列表
export const ActivityNoticeTemplateList = (params) => {
  return axios.post(`${base}/api/ActivityNoticeTemplate/list`, params)
}
export const GetTemplateListByType = (params) => {
  return axios.get(`${base}/api/ActivityNoticeTemplate/type/${params}/list`, {})
}
export const GetTemplateListByActivityId = (params) => {
  return axios.get(
    `${base}/api/ActivityNoticeTemplate/activity/${params}/list`,
    {}
  )
}
// 模板 新增或编辑
export const AddOrUpdActivityTemplate = (params) => {
  return axios.post(`${base}/api/ActivityNoticeTemplate/addOrUpd`, params)
}
//  根据 模板ID  获取详情
export const getActTemplateInfo = (params) => {
  return axios.get(`${base}/api/ActivityNoticeTemplate/info/${params}`, {})
}
//  根据 模板ID  删除模板
export const DelActTemplate = (params) => {
  return axios.delete(`${base}/api/ActivityNoticeTemplate/del/${params}`, {})
}
// 根据 模板类型ID  查找模板列表
export const getActNotTempListByTypes = (params) => {
  return axios.post(`${base}/api/ActivityNoticeTemplate/${params}/list`, {})
}

// 短信——签名列表
export const getSmsSignlist = (params) => {
  return axios.get(`${base}/api/ALiYun/sms/signlist`, params)
}
// 短信——模板列表
export const getSmsTemplatelist = (params) => {
  return axios.get(`${base}/api/ALiYun/sms/templatelist`, params)
}
// 短信——验证码
export const getSmsCode = (params) => {
  if (params.cacheTime)
    return axios.get(
      `${base}/api/ALiYun/sms/code/${params.type}/${params.phoneNumber}?cacheTime=${params.cacheTime}`,
      {}
    )
  return axios.get(
    `${base}/api/ALiYun/sms/code/${params.type}/${params.phoneNumber}`,
    {}
  )
}

/**
 *  公共枚举
 */
// 1. 获取员工数量范围
export const getEmployeeNumRange = (params) => {
  return axios.get(`${base}/api/ComEnum/EmployeeNumRange/list`, params)
}
// 2. 获取所属行业列表
export const getIndustryList = (params) => {
  return axios.get(`${base}/api/ComEnum/Industry/list`, params)
}
// 3. 获取城市列表
export const getProvinceList = (params) => {
  return axios.get(`${base}/api/ComEnum/Province/list`, params)
}
// 4. 获取奖项状态列表
export const getAwardStatusList = (params) => {
  return axios.get(`${base}/api/ComEnum/AwardApplication/Status/list`, params)
}

/**
 *  奖项申报——填报、补录
 */

//  根据 ID  获取奖项活动名称
export const getAwardNameById = (params) => {
  return axios.get(`${base}/api/Award/${params}`, {})
}

export const getAwardNameByEncryptId = (params) => {
  return axios.get(`${base}/api/Award/v2/${params}`, {})
}
// 获取奖项类型列表
// export const getApplyAwardTypeList = (params) => {
//   return axios.get(`${base}/api/ApplyAwardType/list`, params)
// }
// 推荐机构 列表
export const getInstitutionList = (params) => {
  return axios.get(`${base}/api/AwardApplication/institution/list`, params)
}
// 奖项填报 新增或编辑
export const AddOrUpdAwardApplication = (params) => {
  return axios.post(`${base}/api/AwardApplication/addOrUpd`, params)
}
// 通过 SCC + 手机号 获取填报详细信息
export const getAwardApplicationInfo = (params) => {
  return axios.post(`${base}/api/AwardApplication/info`, params)
}

// 补录信息提交
export const getAwardReplenishAdd = (params) => {
  return axios.post(`${base}/api/AwardApplication/replenish/add`, params)
}

// 获取奖项申报列表
export const getAwardApplicationList = (params) => {
  return axios.post(`${base}/api/AwardApplication/list`, params)
}
// 获取奖项活动名称列表
export const getAwardNameList = (params) => {
  return axios.get(`${base}/api/Award/list`, params)
}
// 根据 ID  查找详情
export const getAwardInfoById = (params) => {
  return axios.get(`${base}/api/AwardApplication/${params}/info`, {})
}
// 获奖详情 保存 按钮功能
export const getAwardModify = (params) => {
  return axios.post(`${base}/api/AwardApplication/Modify`, params)
}
// 获奖详情 退回、初审通过、终审通过  状态修改
export const awardUpdateStatus = (params) => {
  return axios.get(
    `${base}/api/AwardApplication/${params.id}/status/${params.status}`,
    {}
  )
}
// 根据 填报数据时的 ID 查询补录记录
export const getReplenishList = (params) => {
  return axios.get(`${base}/api/AwardApplication/${params}/replenish/list`, {})
}

export const getAwardReportUrl = (params) => {
  return axios.get(
    `${base}/api/AwardApplication/report/${params.awardId}/${params.awardTypeId}`,
    {}
  )
}

// 通过加密 ID 获取填报企业的信息
export const getAwardApplicationInfoByID = (params) => {
  return axios.get(`${base}/api/AwardApplication/v2/${params}/info`, {})
}

export const getAwardApplicationInfoByEncryptReplenishId = (params) => {
  return axios.get(`${base}/api/AwardApplication/replenish/${params}/info`, {})
}
// 上传附件
export const getAwardAttachments = (params) => {
  return axios.post(`${base}/api/AwardApplication/v2/attachments/post`, params)
}

export const getAwardAttachmentList = (params) => {
  return axios.get(`${base}/api/AwardApplication/${params}/attachment/list`, {})
}
// 补填提交
export const submitAwardReplenish = (params) => {
  return axios.post(`${base}/api/AwardApplication/v2/replenish/post`, params)
}
export const addAwardReplenish = (params) => {
  return axios.post(`${base}/api/AwardApplication/replenish/add`, params)
}
export const submitSendnotice = (params) => {
  return axios.post(`${base}/api/AwardApplication/sendnotice`, params)
}

export const getAttachmentUrl = (params) => {
  return axios.post(`${base}/api/AwardApplication/attachment/url`, params)
}

export const asyncOwner = (params) => {
  return axios.get(`${base}/api/AwardApplication/${params}/AsyncOwner`, {})
}
export const enabledAwardApplication = (params) => {
  return axios.post(`${base}/api/AwardApplication/enabled`, params)
}

export const addVueLog = (params) => {
  return axios.post(`${base}/api/VueLog/add`, params)
}
